'use client';
/** @jsxImportSource @emotion/react */

import type { ListItemAvatarProps } from '@mui/material/ListItemAvatar';

import MuiListItemAvatar from '@mui/material/ListItemAvatar';

/**
 * @deprecated Please use `List.ItemAffix` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type { ListItemAvatarProps };
/**
 * @deprecated Please use `List.ItemAffix` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItemAvatar = MuiListItemAvatar;
